import React, { useState } from 'react';

const useFormValues = callback => {
  const [inputs, setInputs] = useState({});
  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
  };

  const handleInputChange = (event, setValues, prevValues, groupName, value) => {
    groupName !== 'basalPercentageOfTDD' && event.persist();
    // console.log('GroupName: ');
    // console.log(groupName);

    // console.log(event);
    // console.log('event.target.value:  ' + event.target.value);

    var localValues = groupName
      ? { ...inputs, [groupName]: event.target.value ? event.target.value : value }
      : { ...inputs, [event.target.name]: event.target.value };
    const groupNameUse = groupName ? groupName : event.target.name;
    console.log('localValues');
    console.log(localValues);

    //calculate TDD
    const tdd = (
      Number(
        localValues.training === 'reducedDose' ? localValues.dailyInsulinDose : localValues.dailyInsulinDose * 0.75
      ) +
      (Number(localValues.patientWeight) * 0.23) / 2
    ).toFixed(2);

    const computedBasalRate = (tdd * (localValues.basalPercentageOfTDD / 100)) / 24;

    const computedDailyBolusDose = tdd - computedBasalRate;

    const computedISF = Number(1700 / tdd).toFixed(2);
    const computedInsulinToCarbRatio = Number(localValues.dailyCarbs / computedDailyBolusDose).toFixed(2);

    groupName
      ? setInputs(inputs => ({
          ...inputs,
          [groupName]: event.target.value ? event.target.value : value,
          ['tddCalculated']: tdd,
          ['computedBasalRate']: computedBasalRate,
          computedDailyBolusDose,
          computedISF,
          computedInsulinToCarbRatio
        }))
      : setInputs(inputs => ({
          ...inputs,
          [event.target.name]: event.target.value,
          ['tddCalculated']: tdd,
          ['computedBasalRate']: computedBasalRate,
          computedDailyBolusDose,
          computedISF,
          computedInsulinToCarbRatio
        }));

    // setField('tdd', tdd);
    // setField('computedISF', computedISF);
    // setField('computedInsulinToCarbRatio', computedInsulinToCarbRatio);
    setValues({
      ...prevValues,
      sensitivityArray: [
        {
          id: 'computedISF',
          time: '00:00',
          val: computedISF
        }
      ],
      bolusArray: [
        {
          id: 'computedInsulinToCarbRatio',
          time: '00:00',
          val: computedInsulinToCarbRatio
        }
      ],
      basalArray: [
        {
          id: 'computedBasalRate',
          time: '00:00',
          val: computedBasalRate
        }
      ],
      computedISF,
      computedInsulinToCarbRatio,
      tdd,
      [groupNameUse]: event.target.value ? event.target.value : value
    });
  };

  return {
    handleSubmit,
    handleInputChange,
    inputs
  };
};

export default useFormValues;
